import React from 'react';
import { Layout, Typography } from 'antd';
import gibobsLogo from '../../../assets/icons/Gibobs.svg';

const { Header } = Layout;
const { Text } = Typography;

/**
 * Public onboarding header: logo + divider + "Hipotecas". Drops the right-hand
 * user area of the app header (notifications, avatar, language), since the
 * handoff landing runs unauthenticated.
 */
const OnboardingHeader = () => {
	return (
		<Header
			style={{
				position: 'relative',
				zIndex: 3,
				backgroundColor: '#FFFFFF',
				display: 'flex',
				alignItems: 'center',
				borderBottom: '1px solid rgba(64, 64, 64, 0.08)',
				boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
			}}>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<img src={gibobsLogo} alt="gibobs" height={32} style={{ objectFit: 'contain' }} />
				<div
					style={{
						width: 1.2,
						height: 34,
						backgroundColor: '#02C3CD',
						margin: '0 16px'
					}}
				/>
				<Text style={{ fontSize: 14, fontWeight: 600, color: '#02C3CD' }}>Hipotecas</Text>
			</div>
		</Header>
	);
};

export default OnboardingHeader;
